import socket from './service/socket'
import { SocketServerHost } from './config'
import {
	SOCKET_SEND_ACTION,
	SOCKET_RECEIVE_ACTION
} from './service/socket-const'
import event from 'cocos/framework/components/event'

let PvpManagerInstance = null
export class FriendPvpManager extends event {
	constructor() {
		super()
		this.id = null // 友谊赛长连接里需要发
		this.me = null
		this.you = null
		this.gameResult = {
			self:{
				targetFinish:0, targetTotal:0, score:0, time:0, reslut:0
			},
			enemy:{
				targetFinish:0, targetTotal:0, score:0, time:0, reslut:0
			}
		}
		this.creator = null
		this.activityInfo = null;
		this.rankListVersion = 0;
		this.needRequestRankList = false;
		this.isInviteMode = true; // 是否是被邀请的
		this.isInvitedPlayer = true; // 是否是被邀请的
		this.gameRestTime = -1; // 游戏内剩余时间，通过心跳表更新
		this.mode = 1; // 友谊赛长连接里需要发全为1
		this.isRobot = false; // 机器人没有长连接
		this.heartPing = 0;
		this.heartPong = 0;
		this.updateProgressTime = 0;
		this.roomHost = null;	// 房主uid
		this.enemyHasLeftRoom = false;
		this.bind(this)
	}

	static getInstance() {
		return PvpManagerInstance ? PvpManagerInstance : (PvpManagerInstance = new FriendPvpManager())
	}

	// -- Map{
	// --       freeCount:int                        今天剩余免费次数
	// --       adCount:int                          今天剩余看视频次数
	// --       adTicketCount:int                    今天剩余看视频获得的次数
	// -- }
	setActivityInfo(info){
		// 排行榜的号码，如果号码没变的话不去重新拉取
		if (this.rankListVersion != info.version){
			this.needRequestRankList = true;
		}
		this.rankListVersion = info.version; 
		this.activityInfo = info;
	}

	getActivityInfo(info){
		return this.activityInfo;
	}

	getNeedRequestRankList(){
		return this.needRequestRankList;
	}

	// Map{
	// 	--  myRankInfo:{
	// 	--       rank:int                            排名,未上榜为0
	// 	--       nickname:String                     昵称
	// 	--       avatar:String                       头像
	// 	--       totalScore:int                      总积分
	// 	--       winRate:String                      胜率        
	// 	--  }
	// 	--  list:[{
	// 	--       rank:int                            排名
	// 	--       nickname:String                     昵称
	// 	--       avatar:String                       头像
	// 	--       totalScore:int                      总积分
	// 	--       winRate:String                      胜率        
	// 	--  }]      
	// 	-- }
	setRankList(data){
		this.rankListData = data;
	}

	getRankList(){
		return this.rankListData;
	}

	listenSocket() {}

	createRoom(userInfo, onSuccess, onError) {
		this.me = this.creator = userInfo
		// let uid = UserManager.getInstance().uid
		// this.id = uid
		this.connect().then(() => {
			socket.emit(SOCKET_SEND_ACTION.CreateRoom, {mode:this.mode, supportReconnect: true})
			onSuccess && onSuccess()
		}).catch(onError)
	}

	joinRoom(roomId, userInfo, onError) {
		this.id = roomId
		this.me = userInfo
		this.connect().then(() => socket.emit(SOCKET_SEND_ACTION.JoinRoom, {roomId: this.id, mode:this.mode, supportReconnect: true})).catch(onError)
	}
	
	startReconnect(onSuccess, onError, onCancel, roomId) {
		let called = false
		let loadId = false
		if (roomId){
			// 带roomId的应该是闪退恢复重连的
			this.id = roomId;
		}
		function createCallback(cb, time = 0) {
            return function () {
                if (!called) {
                    called = true
					setTimeout(()=>{
						loadId && LoadingPanelLogic.getInstance().remove(loadId)
						cb && cb()
					}, time);
                }
            }
		}
		onSuccess = createCallback(onSuccess)
		onCancel = createCallback(onCancel, 2000)
		onError = createCallback(onError, 2000)

		loadId = LoadingPanelLogic.getInstance().add(null, onCancel)
		this.connect().then(() => {
			socket.emit(SOCKET_SEND_ACTION.Reconnect, {roomId: this.id, mode:this.mode})
			onSuccess && onSuccess()
		}).catch(onError)
	}

	startGame() {
		let self = this
		if (self.isRobot){
			var levelId = self.you.levelId;
			this.dispatchEvent({
				name: SOCKET_RECEIVE_ACTION.DispatcherConfig,
				data:{
					levelId:levelId
				}
			})
		}else{
			socket.emit(SOCKET_SEND_ACTION.StartGame, {roomId: this.id, mode:this.mode})
		}
	}

	leaveRoom() {
		socket.emit(SOCKET_SEND_ACTION.LeaveRoom, {roomId: this.id, mode:this.mode})
	}

	pvpLeaveRoom() {
		let self = this;
		if (self.isRobot){
			this.dispatchEvent({
				name: SOCKET_RECEIVE_ACTION.PvpLeaveRoom
			})
		}
		socket.emit(SOCKET_SEND_ACTION.PvpLeaveRoom, {roomId: this.id, mode:this.mode})
	}

	updateProgress(progress, score, force = false) {
		let self = this;
		// 机器人和对手已经离开的情况不刷新
		if (self.isRobot || self.enemyHasLeftRoom){
			return;
		}
		var currentScene = cc.director._runningScene;
		if ((currentScene.name == "GameScene" || currentScene.name == "ReplayGameScene") && currentScene.logic.replaying) {
			// 关卡恢复时不同步
			return;
		}
		var curTime = Localhost.time();
		var dt = curTime - self.updateProgressTime;
		if (dt <= 5000 && force == false){
			self.nextAutoUpdate(progress, score, dt);
			return
		}
		self.updateProgressTime = curTime;
		socket.emit(SOCKET_SEND_ACTION.PvpUpdateProgress, {roomId: this.id, mode:this.mode, progress: progress, score:score});
	}

	nextAutoUpdate(progress, score, dt){
		let self = this;
		// 对手已经离开的情况不刷新
		if (self.enemyHasLeftRoom){
			return;
		}
		// 5秒内第二次分数同步会放到到5秒是时候在同步
		if (self.nextUpdate){
			clearTimeout(self.nextUpdate);
		}
		self.nextUpdate = setTimeout(()=>{
			cc.log("******nextAutoUpdate updateProgress******", progress, score);
			var curTime2 = Localhost.time();
			if (curTime2 - self.updateProgressTime > 5000 && socket.isConnected){ 
				self.updateProgress(progress, score);
			}
		}, 5100-dt);
	}

	sendHeart() {
		let self = this;
		if (self.isRobot){
			return;
		}
		cc.log("heartPing heartPong");
		cc.log(self.heartPing, self.heartPong);
		if (self.heartPing - self.heartPong > 1){
			self.heartPing = 0;
			self.heartPong = 0;
			var onSuccess = function(){
				self.clearEvent()
				self.initSocket()
				self.startReconnect(() => {
					Toast.make("重新连接服务器成功！")
					self.reconnenting = false
				}, () => {
					
				});
			}
			self.closeSocket(onSuccess, onSuccess);
			return;
		}
		self.heartPing += 1;
		socket.emit(SOCKET_SEND_ACTION.Heart, {roomId: this.id, mode:this.mode});
	}

	// costTime和result是机器人用
	sendPvpResult(progress, score, leftSteps, targetFinishNum, targetTotal, costTime, result){
		let self = this;
		if (self.isRobot){
			var onSuccess = function(evt){
				var data = {};
				data.result = result;
				if (result == 1){
					data.targetResult = 2;
				}else if (result == 2){
					data.targetResult = 1;
				}else if (result == 3){
					data.targetResult = 3;
				}else if (result == 5){
					data.targetResult = 1;
				}
				data.targetCollect = targetTotal;
				data.targetScore = self.you.score;
				data.targetTime = self.you.time;

				self.dispatchEvent({
					name: SOCKET_RECEIVE_ACTION.PvpRobotResult,
					data:data
				})
			}
			var onFail = function(evt){
				cc.error(evt);
			}
			var http = PvpResultHttp.new();
			http.addEventListener(Events.kComplete, onSuccess);
			http.addEventListener(Events.kError, onFail);
			http.addEventListener(Events.kCancel, onFail);
			http.load(progress, score, targetFinishNum, targetTotal, costTime, result, self.you.robotUid, self.you.levelId);
			return;
		}
		socket.emit(SOCKET_SEND_ACTION.PvpResult, {roomId: this.id, mode:this.mode, progress:progress, score:score, leftSteps:leftSteps, collect:targetFinishNum, collectMax:targetTotal});
	}

	getRoomId() {
		return this.id
	}

	meIsOwner() {
		return this.me === this.creator
	}
	connect() {
		return new Promise((resolve, reject) => {
			// socket.offType('connect')
			// socket.offType('socket_error')
			// socket.on('connect', resolve)
			// socket.on('socket_error', reject)
			var newToken = encodeURIComponent(tostring(_G.token || 0))
			var pf = isWechatGameEnv()? mini.getPlatform(): META.platform
			socket.url = `${SocketServerHost}?roomid=${this.id}&token=${_G.token}&newToken=${newToken}&pf=${pf}&mode=${this.mode}&room_host=${this.meIsOwner()? UserManager.getInstance().uid: this.roomHost}`
			socket.connect().then(resolve).catch(reject)
			this.isSetting = false
			
			if (window.logCenter){
				let msg = {
					message: "pvp socket url: " + socket.url
				}
				window.logCenter.log(msg)
			}
		})
	}

	getSetting() {
		return this.isSetting
	}

	setSetting(value){
		this.isSetting = value
	}

	closeSocket(onSuccess, onFail) {
		try {
			if (socket.isConnected) {
				socket.close().then(() => {
					cc.log("----close socket ok----")
					onSuccess && onSuccess()
				}, () => {
					cc.log("----close socket error----")
					onFail && onFail()
				})
			}else{
				onSuccess && onSuccess()
			}
		} catch (error) {
			cc.log(error)
			onError && onError()
		}
	}

	restartGame() {
		socket.emit(SOCKET_SEND_ACTION.Restart)
	}

	setPvpMode(mode){
		let self = this;
		if (self.isRobot){
			return;
		}
		socket.emit(SOCKET_SEND_ACTION.PvpMode, {mode: mode});
	}

	clearGameResult(){
		this.gameResult = null
	}

	isEnemyLeave() {
		return this.you === null
	}

	clearEvent() {
		cc.log("----FriendPvpManager clearEvent----");
		socket.removeAllListeners()
	}

	initSocket() {
		cc.log("----FriendPvpManager initSocket----");
		socket.on(SOCKET_RECEIVE_ACTION.CreateRoom, (data) => {
			this.id = data.sRoomId
			this.me.winRate = data.winRate
			this.me.winTimes = data.winTimes
			this.me.rowWinTimes = data.rowWinTimes
			this.dispatchEvent({
				name: SOCKET_RECEIVE_ACTION.CreateRoom
			})
		})
		socket.on(SOCKET_RECEIVE_ACTION.JoinRoom, userInfo => {
			this.you = userInfo;
			userInfo.name = HeDisplayUtil.urlDecode(userInfo.name)

			this.me.winTimes = userInfo.myWinTimes
			this.me.rowWinTimes = userInfo.myRowWinTimes
			this.me.winRate = userInfo.myWinRate

			this.dispatchEvent({
				name: SOCKET_RECEIVE_ACTION.JoinRoom,
				data: userInfo
			})
		})
		socket.on(SOCKET_RECEIVE_ACTION.LeaveRoom, userInfo => {
			this.you = null
			this.dispatchEvent({
				name: SOCKET_RECEIVE_ACTION.LeaveRoom,
				data: userInfo
			})
		})
		socket.on(SOCKET_RECEIVE_ACTION.PvpLeaveRoom, userInfo => {
			// this.you = null
			this.dispatchEvent({
				name: SOCKET_RECEIVE_ACTION.PvpLeaveRoom,
				data: userInfo
			})
		})
		socket.on(SOCKET_RECEIVE_ACTION.DispatcherConfig, config => {
			this.config = config
			this.dispatchEvent({
				name: SOCKET_RECEIVE_ACTION.DispatcherConfig,
				data: config
			})
		})
		socket.on(SOCKET_RECEIVE_ACTION.PvpUpdateProgress, progress => {
			this.gameResult.enemyProgress = progress;
			this.dispatchEvent({
				name: SOCKET_RECEIVE_ACTION.PvpUpdateProgress,
				data: progress
			})
		})
		socket.on(SOCKET_RECEIVE_ACTION.Heart, heart => {
			this.heartPong += 1;
			this.dispatchEvent({
				name: SOCKET_RECEIVE_ACTION.Heart,
				data: heart
			})
		})
		socket.on(SOCKET_RECEIVE_ACTION.PvpResult, data => {
			this.dispatchEvent({
				name: SOCKET_RECEIVE_ACTION.PvpResult,
				data: data
			})
		})
		socket.on(SOCKET_RECEIVE_ACTION.Restart, () => {
			this.dispatchEvent({
				name: SOCKET_RECEIVE_ACTION.Restart
			})
		})
		socket.on(SOCKET_RECEIVE_ACTION.Error, error => {
			this.dispatchEvent({
				name: SOCKET_RECEIVE_ACTION.Error,
				data: error
			})
		})
		socket.on("close", () => {
			this.dispatchEvent({
				name: SOCKET_RECEIVE_ACTION.SocketClosed
			})
		})
		socket.on(SOCKET_RECEIVE_ACTION.Reconnect, progress => {
			if (this.isRobot){
				return;
			}
			this.dispatchEvent({
				name: SOCKET_RECEIVE_ACTION.PvpUpdateProgress,
				data: progress
			})
		}),
		socket.on("socket_error", () => {
			if (this.isRobot){
				return;
			}
			this.dispatchEvent({
				name: "socket_error"
			})
		})
	}
}